module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "new-campaign-devices-and-services"
  }, [_c('v-snackbar', {
    attrs: {
      "timeout": _vm.snackbar.timeout,
      "top": "",
      "color": _vm.snackbar.color,
      "rounded": "",
      "centered": ""
    },
    model: {
      value: (_vm.snackbar.show),
      callback: function($$v) {
        _vm.$set(_vm.snackbar, "show", $$v)
      },
      expression: "snackbar.show"
    }
  }, [_vm._v("\n    " + _vm._s(_vm.snackbar.text) + "\n  ")]), _vm._v(" "), (_vm.warningDialog.show) ? _c('v-dialog', {
    attrs: {
      "width": "auto"
    },
    model: {
      value: (_vm.warningDialog.show),
      callback: function($$v) {
        _vm.$set(_vm.warningDialog, "show", $$v)
      },
      expression: "warningDialog.show"
    }
  }, [_c('div', {
    staticClass: "start-date-warning-dialog"
  }, [_c('v-card', {
    staticClass: "py-4 px-4",
    attrs: {
      "color": "#EEF2F5",
      "rounded": "lg"
    }
  }, [_c('v-card-title', {
    staticClass: "justify-center pt-4"
  }, [_c('v-img', {
    attrs: {
      "src": require('@/assets/icons/alert.png'),
      "max-width": "1.5rem",
      "max-height": "1.5rem"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "title-text ml-2 mb-0"
  }, [_vm._v(_vm._s(_vm.$t('NewCampaignInitialData.devicesAndServices.startDateWarningTitle')))])], 1), _vm._v(" "), _c('v-card-text', {
    staticClass: "body-text text-center px-6"
  }, [_c('p', {
    staticClass: "mb-8"
  }, [_vm._v(_vm._s(_vm.$t('NewCampaignInitialData.devicesAndServices.startDateWarningMessageFirst')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('NewCampaignInitialData.devicesAndServices.startDateWarningMessageSecond')))])]), _vm._v(" "), _c('v-card-actions', [_c('v-row', [_c('v-col', {
    attrs: {
      "align": "center"
    }
  }, [_c('v-btn', {
    staticClass: "confirm-button",
    attrs: {
      "color": "#0098E1",
      "medium": ""
    },
    on: {
      "click": _vm.closeWarningDialog
    }
  }, [_vm._v("\n                " + _vm._s(_vm.$t('Config.ok')) + "\n              ")])], 1)], 1)], 1)], 1)], 1)]) : _vm._e(), _vm._v(" "), (_vm.newDeviceDialog) ? _c('v-dialog', {
    attrs: {
      "width": "500",
      "content-class": "new-device-dialog"
    },
    model: {
      value: (_vm.newDeviceDialog),
      callback: function($$v) {
        _vm.newDeviceDialog = $$v
      },
      expression: "newDeviceDialog"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "new-device-dialog-title text-break justify-center mb-2",
    attrs: {
      "tag": "p"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t('NewCampaignInitialData.devicesAndServices.setNewDeviceTitle')) + "\n      ")]), _vm._v(" "), _c('v-card-text', [_c('v-row', {
    attrs: {
      "justify": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "8"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": ("" + (_vm.$t('NewCampaignInitialData.devicesAndServices.setNewDeviceLabel'))),
      "title": _vm.$t('NewCampaignInitialData.devicesAndServices.setNewDeviceLabel'),
      "background-color": "white",
      "outlined": "",
      "persistent-hint": "",
      "flat": "",
      "rules": [_vm.rules.fieldRequired],
      "hide-details": "auto"
    },
    model: {
      value: (_vm.newDeviceName),
      callback: function($$v) {
        _vm.newDeviceName = $$v
      },
      expression: "newDeviceName"
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', {
    staticClass: "mt-2",
    attrs: {
      "justify": "center"
    }
  }, [_c('v-btn', {
    staticClass: "submit-button",
    attrs: {
      "loading": _vm.loadingNewDevice,
      "disabled": !_vm.newDeviceName,
      "color": "#0098E1"
    },
    on: {
      "click": function($event) {
        return _vm.createNewDevice()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('NewCampaignInitialData.devicesAndServices.setNewDeviceSubmitButton')))])], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.addUserDialog) ? _c('AddUserDialog', {
    attrs: {
      "dialog": _vm.addUserDialog,
      "fromNewCampaign": true,
      "campaignId": _vm.campaignId
    },
    on: {
      "update:dialog": function($event) {
        _vm.addUserDialog = $event
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "title-text mt-2"
  }, [_vm._v(_vm._s(_vm.$t('NewCampaignInitialData.devicesAndServices.title')))]), _vm._v(" "), _c('p', {
    staticClass: "body-text text-center mt-2"
  }, [_vm._v(_vm._s(_vm.$t('NewCampaignInitialData.devicesAndServices.subtitle')))]), _vm._v(" "), _c('v-row', {
    staticClass: "mt-2",
    attrs: {
      "justify": "center",
      "align": "center"
    }
  }, [_c('v-img', {
    attrs: {
      "src": require('@/assets/icons/lightbulb.png'),
      "max-width": "1.25rem",
      "max-height": "1.25rem"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "body-text text-center font-italic ml-2 mb-0"
  }, [_vm._v(_vm._s(_vm.$t('NewCampaignInitialData.devicesAndServices.tip')))]), _vm._v(" "), _c('v-btn', {
    staticClass: "invite-users-button ml-4",
    attrs: {
      "loading": _vm.loadingInviteUsers,
      "color": "#0098E1",
      "small": ""
    },
    on: {
      "click": function($event) {
        return _vm.inviteUsers()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('NewCampaignInitialData.devicesAndServices.inviteUsers')))])], 1), _vm._v(" "), _c('p', {
    staticClass: "section-text text-left pt-4"
  }, [_vm._v(_vm._s(_vm.$t('NewCampaignInitialData.devicesAndServices.contractedEquipmentsTitle')))]), _vm._v(" "), _c('v-form', {
    ref: "productsForm",
    staticClass: "action-row",
    model: {
      value: (_vm.isFormValid),
      callback: function($$v) {
        _vm.isFormValid = $$v
      },
      expression: "isFormValid"
    }
  }, [_c('div', [_vm._l((_vm.monitoringProducts), function(product, index) {
    return [_c('v-row', {
      attrs: {
        "align": "baseline"
      }
    }, [_c('p', {
      staticClass: "body-text pointer",
      on: {
        "click": function($event) {
          return _vm.toggleProductExpanded('monitoring', index)
        }
      }
    }, [_c('b', [_vm._v(_vm._s(product.quantity))]), _vm._v(" " + _vm._s(_vm.getProductDetailText(product)))]), _vm._v(" "), _c('v-btn', {
      staticClass: "ml-2",
      attrs: {
        "text": "",
        "fab": "",
        "x-small": ""
      },
      on: {
        "click": function($event) {
          return _vm.toggleProductExpanded('monitoring', index)
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "color": "black"
      }
    }, [_vm._v(_vm._s(_vm.monitoringProductsExpanded[index] ? 'mdi-chevron-up' : 'mdi-chevron-down'))])], 1)], 1), _vm._v(" "), _vm._l((_vm.monitoringProductsData[index].devices), function(deviceInfo, deviceIndex) {
      return _c('div', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (_vm.monitoringProductsExpanded[index]),
          expression: "monitoringProductsExpanded[index]"
        }]
      }, [_c('v-row', [_c('v-col', {
        attrs: {
          "cols": "12",
          "md": "2"
        }
      }, [_c('v-autocomplete', {
        attrs: {
          "menu-props": {
            offsetY: true
          },
          "items": _vm.newDevicesItemsList[(index + "-" + deviceIndex)] ?
            [{
              id: (index + "-" + deviceIndex),
              campaign: {
                entityName: _vm.newDevicesItemsList[(index + "-" + deviceIndex)].name
              }
            } ].concat( _vm.getDevices(deviceInfo.device, product.deviceType)) :
            _vm.getDevices(deviceInfo.device, product.deviceType),
          "item-text": "campaign.entityName",
          "item-value": "id",
          "label": ((_vm.$t('NewCampaignInitialData.devicesAndServices.device')) + " *"),
          "title": _vm.$t('NewCampaignInitialData.devicesAndServices.device'),
          "outlined": "",
          "background-color": "#FFF",
          "color": "#0098E1",
          "rules": [_vm.rules.fieldRequired],
          "hide-details": "auto",
          "no-data-text": _vm.$t('NewCampaignInitialData.devicesAndServices.noDevices')
        },
        on: {
          "change": function($event) {
            return _vm.handleSelectDevice(index, deviceIndex)
          }
        },
        scopedSlots: _vm._u([{
          key: "prepend-item",
          fn: function() {
            return [_c('v-list-item', {
              on: {
                "click": function($event) {
                  return _vm.addNewDevice(index, deviceIndex)
                }
              }
            }, [_c('v-list-item-title', {
              staticClass: "add-field-btn"
            }, [_vm._v("\n                      + " + _vm._s(_vm.$t('NewCampaignInitialData.devicesAndServices.addNewDevice')) + "\n                    ")])], 1)]
          },
          proxy: true
        }], null, true),
        model: {
          value: (deviceInfo.device),
          callback: function($$v) {
            _vm.$set(deviceInfo, "device", $$v)
          },
          expression: "deviceInfo.device"
        }
      })], 1), _vm._v(" "), _c('v-col', {
        attrs: {
          "cols": "12",
          "md": "2"
        }
      }, [_c('v-menu', {
        attrs: {
          "close-on-content-click": false,
          "transition": "scale-transition",
          "offset-y": "",
          "min-width": "auto"
        },
        scopedSlots: _vm._u([{
          key: "activator",
          fn: function(ref) {
            var on = ref.on;
            var attrs = ref.attrs;

            return [_c('v-text-field', _vm._g(_vm._b({
              key: ("startDate-" + index),
              attrs: {
                "label": ((_vm.$t('NewCampaignInitialData.devicesAndServices.startDate')) + " *"),
                "title": _vm.$t('NewCampaignInitialData.devicesAndServices.startDate'),
                "background-color": "white",
                "readonly": "",
                "outlined": "",
                "persistent-hint": "",
                "flat": "",
                "color": "#0098E1",
                "clearable": "",
                "rules": [_vm.rules.fieldRequired, _vm.rules.validateStartDate],
                "hide-details": "auto",
                "append-icon": "mdi-calendar"
              },
              on: {
                "click:append": function($event) {
                  deviceInfo.startDateMenu = true
                }
              },
              model: {
                value: (deviceInfo.startDate),
                callback: function($$v) {
                  _vm.$set(deviceInfo, "startDate", $$v)
                },
                expression: "deviceInfo.startDate"
              }
            }, 'v-text-field', attrs, false), on))]
          }
        }], null, true),
        model: {
          value: (deviceInfo.startDateMenu),
          callback: function($$v) {
            _vm.$set(deviceInfo, "startDateMenu", $$v)
          },
          expression: "deviceInfo.startDateMenu"
        }
      }, [_vm._v(" "), _c('v-date-picker', {
        attrs: {
          "color": "#0098E1",
          "locale": "es-AR",
          "min": _vm.getCurrentDate()
        },
        on: {
          "change": function($event) {
            return _vm.handleDeviceDateChange($event, deviceInfo, 'startDate')
          }
        },
        model: {
          value: (deviceInfo.auxStartDate),
          callback: function($$v) {
            _vm.$set(deviceInfo, "auxStartDate", $$v)
          },
          expression: "deviceInfo.auxStartDate"
        }
      })], 1)], 1), _vm._v(" "), _c('v-col', {
        attrs: {
          "cols": "12",
          "md": "2"
        }
      }, [_c('v-menu', {
        attrs: {
          "close-on-content-click": false,
          "transition": "scale-transition",
          "offset-y": "",
          "min-width": "auto"
        },
        scopedSlots: _vm._u([{
          key: "activator",
          fn: function(ref) {
            var on = ref.on;
            var attrs = ref.attrs;

            return [_c('v-text-field', _vm._g(_vm._b({
              key: ("endDate-" + index),
              attrs: {
                "label": ((_vm.$t('NewCampaignInitialData.devicesAndServices.endDate')) + " *"),
                "title": _vm.$t('NewCampaignInitialData.devicesAndServices.endDate'),
                "background-color": "white",
                "readonly": "",
                "outlined": "",
                "persistent-hint": "",
                "flat": "",
                "color": "#0098E1",
                "clearable": "",
                "rules": [_vm.rules.fieldRequired, function (v) { return _vm.validateEndDateForDevice(v, deviceInfo, _vm.monitoringProductsData[index]); }],
                "disabled": !deviceInfo.startDate || _vm.deviceHasExtension(index, deviceIndex),
                "hide-details": "auto",
                "append-icon": "mdi-calendar"
              },
              on: {
                "click:append": function($event) {
                  deviceInfo.endDateMenu = true
                }
              },
              model: {
                value: (deviceInfo.endDate),
                callback: function($$v) {
                  _vm.$set(deviceInfo, "endDate", $$v)
                },
                expression: "deviceInfo.endDate"
              }
            }, 'v-text-field', attrs, false), on))]
          }
        }], null, true),
        model: {
          value: (deviceInfo.endDateMenu),
          callback: function($$v) {
            _vm.$set(deviceInfo, "endDateMenu", $$v)
          },
          expression: "deviceInfo.endDateMenu"
        }
      }, [_vm._v(" "), _c('v-date-picker', {
        attrs: {
          "color": "#0098E1",
          "locale": "es-AR",
          "min": _vm.getCurrentDate()
        },
        on: {
          "change": function($event) {
            return _vm.handleDeviceDateChange($event, deviceInfo, 'endDate')
          }
        },
        model: {
          value: (deviceInfo.auxEndDate),
          callback: function($$v) {
            _vm.$set(deviceInfo, "auxEndDate", $$v)
          },
          expression: "deviceInfo.auxEndDate"
        }
      })], 1)], 1), _vm._v(" "), _c('v-col', {
        attrs: {
          "cols": "12",
          "md": "2"
        }
      }, [_c('v-autocomplete', {
        attrs: {
          "menu-props": {
            offsetY: true
          },
          "items": _vm.fields,
          "item-text": "name",
          "item-value": "id",
          "label": ((_vm.$t('NewCampaignInitialData.devicesAndServices.field')) + " *"),
          "title": _vm.$t('NewCampaignInitialData.devicesAndServices.field'),
          "outlined": "",
          "background-color": "#FFF",
          "color": "#0098E1",
          "rules": [_vm.rules.fieldRequired],
          "hide-details": "auto",
          "no-data-text": _vm.$t('NewCampaignInitialData.devicesAndServices.noFields')
        },
        on: {
          "change": _vm.handleDataChange
        },
        scopedSlots: _vm._u([{
          key: "prepend-item",
          fn: function() {
            return [_c('v-list-item', {
              on: {
                "click": function($event) {
                  return _vm.addNewField(index, deviceIndex)
                }
              }
            }, [_c('v-list-item-title', {
              staticClass: "add-field-btn"
            }, [_vm._v("\n                      + " + _vm._s(_vm.$t('NewCampaignInitialData.devicesAndServices.addNewField')) + "\n                    ")])], 1)]
          },
          proxy: true
        }], null, true),
        model: {
          value: (deviceInfo.field),
          callback: function($$v) {
            _vm.$set(deviceInfo, "field", $$v)
          },
          expression: "deviceInfo.field"
        }
      })], 1), _vm._v(" "), _c('v-col', {
        attrs: {
          "cols": "12",
          "md": "4"
        }
      }, [_c('v-text-field', {
        attrs: {
          "label": ((_vm.$t('NewCampaignInitialData.devicesAndServices.coordinates')) + " *"),
          "title": _vm.$t('NewCampaignInitialData.devicesAndServices.coordinates'),
          "hint": _vm.$t('NewCampaignInitialData.devicesAndServices.coordinatesHint'),
          "background-color": "white",
          "outlined": "",
          "persistent-hint": "",
          "flat": "",
          "rules": [_vm.rules.fieldRequired, _vm.rules.validateLatLon],
          "hide-details": "auto",
          "validate-on-blur": ""
        },
        on: {
          "blur": _vm.handleDataChange
        },
        model: {
          value: (deviceInfo.coordinates),
          callback: function($$v) {
            _vm.$set(deviceInfo, "coordinates", $$v)
          },
          expression: "deviceInfo.coordinates"
        }
      })], 1)], 1), _vm._v(" "), (deviceIndex < _vm.monitoringProductsData[index].devices.length - 1) ? _c('v-divider', {
        staticClass: "mt-2 mb-6"
      }) : _vm._e()], 1)
    })]
  }), _vm._v(" "), _vm._l((_vm.extensionProducts), function(product, index) {
    return [_c('v-row', {
      attrs: {
        "align": "baseline"
      }
    }, [_c('p', {
      staticClass: "body-text pointer",
      on: {
        "click": function($event) {
          return _vm.toggleProductExpanded('extension', index)
        }
      }
    }, [_c('b', [_vm._v(_vm._s(product.quantity))]), _vm._v(" " + _vm._s(_vm.getProductDetailText(product)))]), _vm._v(" "), _c('v-btn', {
      staticClass: "ml-2",
      attrs: {
        "text": "",
        "fab": "",
        "x-small": ""
      },
      on: {
        "click": function($event) {
          return _vm.toggleProductExpanded('extension', index)
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "color": "black"
      }
    }, [_vm._v(_vm._s(_vm.extensionProductsExpanded[index] ? 'mdi-chevron-up' : 'mdi-chevron-down'))])], 1)], 1), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.extensionProductsExpanded[index]),
        expression: "extensionProductsExpanded[index]"
      }]
    }, [_c('v-row', {
      attrs: {
        "align": "baseline"
      }
    }, [_c('p', {
      staticClass: "extension-description-text"
    }, [_vm._v(_vm._s(_vm.$t('NewCampaignInitialData.devicesAndServices.extensionProductsDescription')))])]), _vm._v(" "), _vm._l((_vm.extensionProductsData[index].extensions), function(extensionInfo, extensionIndex) {
      return _c('div', [(extensionIndex > 0) ? _c('v-divider', {
        staticClass: "my-2"
      }) : _vm._e(), _vm._v(" "), _c('v-row', [_c('v-col', {
        attrs: {
          "cols": "12",
          "md": "2"
        }
      }, [_c('v-autocomplete', {
        attrs: {
          "menu-props": {
            offsetY: true
          },
          "items": _vm.getExtensionDevices(extensionInfo.device),
          "item-text": "campaign.entityName",
          "item-value": "id",
          "label": ((_vm.$t('NewCampaignInitialData.devicesAndServices.device')) + " *"),
          "title": _vm.$t('NewCampaignInitialData.devicesAndServices.device'),
          "outlined": "",
          "background-color": "#FFF",
          "color": "#0098E1",
          "hide-details": "auto",
          "no-data-text": _vm.$t('NewCampaignInitialData.devicesAndServices.noDevices'),
          "rules": [function () { return _vm.validateExtensionDevice(extensionInfo); }]
        },
        on: {
          "change": _vm.handleDataChange
        },
        model: {
          value: (extensionInfo.device),
          callback: function($$v) {
            _vm.$set(extensionInfo, "device", $$v)
          },
          expression: "extensionInfo.device"
        }
      })], 1), _vm._v(" "), _c('v-col', {
        attrs: {
          "cols": "12",
          "md": "3"
        }
      }, [_c('v-select', {
        attrs: {
          "menu-props": {
            offsetY: true
          },
          "items": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
          "label": ("" + (_vm.$t('NewCampaignInitialData.devicesAndServices.unitsToExtend'))),
          "title": _vm.$t('NewCampaignInitialData.devicesAndServices.unitsToExtend'),
          "outlined": "",
          "background-color": "#FFF",
          "color": "#0098E1",
          "hide-details": "auto",
          "rules": [function () { return _vm.validateUnitsToExtend(index); }]
        },
        on: {
          "change": _vm.handleDataChange
        },
        model: {
          value: (extensionInfo.unitsToExtend),
          callback: function($$v) {
            _vm.$set(extensionInfo, "unitsToExtend", $$v)
          },
          expression: "extensionInfo.unitsToExtend"
        }
      })], 1), _vm._v(" "), _c('v-col', {
        attrs: {
          "cols": "12",
          "md": "2"
        }
      }, [_c('v-menu', {
        attrs: {
          "close-on-content-click": false,
          "transition": "scale-transition",
          "offset-y": "",
          "min-width": "auto"
        },
        scopedSlots: _vm._u([{
          key: "activator",
          fn: function(ref) {
            var on = ref.on;
            var attrs = ref.attrs;

            return [_c('v-text-field', _vm._g(_vm._b({
              key: ("endDate-" + extensionIndex),
              attrs: {
                "label": ("" + (_vm.$t('NewCampaignInitialData.devicesAndServices.endDate'))),
                "title": _vm.$t('NewCampaignInitialData.devicesAndServices.endDate'),
                "background-color": "white",
                "readonly": "",
                "outlined": "",
                "persistent-hint": "",
                "flat": "",
                "color": "#0098E1",
                "clearable": "",
                "hide-details": "auto",
                "append-icon": "mdi-calendar",
                "disabled": !extensionInfo.device,
                "rules": [function () { return _vm.validateEndDateForExtension(extensionInfo.endDate, extensionInfo, _vm.extensionProductsData[index]); }]
              },
              on: {
                "click:append": function($event) {
                  extensionInfo.endDateMenu = true
                }
              },
              model: {
                value: (extensionInfo.endDate),
                callback: function($$v) {
                  _vm.$set(extensionInfo, "endDate", $$v)
                },
                expression: "extensionInfo.endDate"
              }
            }, 'v-text-field', attrs, false), on))]
          }
        }], null, true),
        model: {
          value: (extensionInfo.endDateMenu),
          callback: function($$v) {
            _vm.$set(extensionInfo, "endDateMenu", $$v)
          },
          expression: "extensionInfo.endDateMenu"
        }
      }, [_vm._v(" "), _c('v-date-picker', {
        attrs: {
          "color": "#0098E1",
          "locale": "es-AR",
          "min": _vm.getCurrentDate()
        },
        on: {
          "change": function($event) {
            return _vm.handleExtensionDateChange($event, extensionInfo, 'endDate')
          }
        },
        model: {
          value: (extensionInfo.auxEndDate),
          callback: function($$v) {
            _vm.$set(extensionInfo, "auxEndDate", $$v)
          },
          expression: "extensionInfo.auxEndDate"
        }
      })], 1)], 1), _vm._v(" "), _c('v-col', {
        attrs: {
          "align-self": "center"
        }
      }, [_c('a', {
        staticClass: "remove-extension-btn",
        on: {
          "click": function($event) {
            return _vm.removeExtension(index, extensionIndex)
          }
        }
      }, [_vm._v(_vm._s(_vm.$t('NewCampaignInitialData.devicesAndServices.removeExtension')))])])], 1)], 1)
    }), _vm._v(" "), (_vm.hasUnassignedExtensions(index)) ? _c('v-row', {
      staticClass: "mt-1",
      attrs: {
        "align": "baseline"
      }
    }, [_c('a', {
      staticClass: "add-extension-btn",
      on: {
        "click": function($event) {
          return _vm.addNewExtension(index)
        }
      }
    }, [_vm._v(_vm._s(_vm.$t('NewCampaignInitialData.devicesAndServices.addNewExtension')))])]) : _vm._e()], 2)]
  })], 2), _vm._v(" "), _c('v-row', {
    staticClass: "mt-2",
    attrs: {
      "align": "end"
    }
  }, [_c('v-col', {
    attrs: {
      "align": "end"
    }
  }, [_c('v-btn', {
    staticClass: "back-button",
    attrs: {
      "color": "#FFFFF"
    },
    on: {
      "click": function($event) {
        return _vm.goBack()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('NewCampaignInitialData.devicesAndServices.back')))])], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "align": "start"
    }
  }, [_c('v-btn', {
    staticClass: "submit-button",
    attrs: {
      "loading": _vm.loading,
      "color": "#0098E1"
    },
    on: {
      "click": function($event) {
        return _vm.finish()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('NewCampaignInitialData.devicesAndServices.finish')))])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4a334d6b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Campaigns/NewCampaignDevicesAndServices.vue
// module id = 1709
// module chunks = 0